module.exports = __webpack_public_path__ + "static/DemeterGreen-f8302931fe969382cbe82ab4685c0a62.jpg";